<template>
	<AppOverlay :opacity="0.8">
		<div class="file-preview-controls">
			<AppButton
				variant="ghost"
				icon="arrow_back"
				class="text-white hover:bg-white/25"
				aria-label="Terug"
				@click="$emit('hidePreview')"
			/>
			<AppButton
				variant="ghost"
				icon="download"
				class="text-white hover:bg-white/25"
				aria-label="Downloaden"
				@click="downloadFile"
			/>
		</div>
		<div class="file-preview-overlay" @click="$emit('hidePreview')">
			<FilePreviewFileBox
				:file-url="fileUrl"
				:content-type="contentType"
				:mode="mode"
				:byte-size="props.file.byteSize"
			/>
		</div>
	</AppOverlay>
</template>

<script lang="ts" setup>
import type { DossierDocument } from "@/composables/useLoanApplicationSortedDocuments";
import { useDossierDocumentUrlStore } from "@/store/useDossierDocumentUrlStore";
import { onKeyStroke } from "@vueuse/core";
import saveAs from "file-saver";
import { computed, ref, watchEffect } from "vue";

const emit = defineEmits<{
	hidePreview: [];
}>();

onKeyStroke("Escape", () => emit("hidePreview"));

const props = withDefaults(
	defineProps<{ file: DossierDocument; mode?: "full" | "thumbnail" }>(),
	{ mode: "full" },
);

const fileBlob = ref<Blob | null>(null);
const fileUrl = ref<string | undefined>();

function downloadFile() {
	if (fileBlob.value) {
		const url = URL.createObjectURL(fileBlob.value);
		saveAs(url, props.file.filename);
		URL.revokeObjectURL(url);
		return;
	}

	if (fileUrl.value) {
		saveAs(fileUrl.value, props.file.filename);
	}
}

const contentType = computed(() => {
	if (fileBlob.value) {
		return fileBlob.value.type;
	}

	return props.file.contentType;
});

watchEffect(() => {
	if (!props.file) {
		return;
	}

	void useDossierDocumentUrlStore()
		.getFileUrl(props.file.id)
		.then((url) => {
			fileUrl.value = url;
		});

	// TODO: cache this file
});
</script>

<style lang="scss">
.file-preview-controls {
	position: absolute;
	background: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0.65) 0%,
		transparent 100%
	);
	top: 0;
	left: 0;
	width: 100%;
	z-index: 1002;
	padding: 1rem;
	display: flex;
	justify-content: space-between;
	scrollbar-gutter: stable;
	overflow-y: auto;
	pointer-events: none;

	--icon-size: 2rem;

	button {
		pointer-events: auto;
	}
}

.file-preview-overlay {
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1001;
	width: 100%;
	height: 100%;
	overflow: auto;

	.file-preview {
		margin: 5rem auto;
		width: 800px;
	}
}
</style>
